export class ActionStateModel {
  /*  */
  save: boolean;
  temporaryRegister: boolean;
  preparationPrint: boolean;
  customerPrint: boolean;
  print: boolean;
  clearWithoutPrint: boolean;
  clear: boolean;
  cancel: boolean;
  mixClear: boolean;
  delivered: boolean;
  constructor() {
    this.save = false;
    this.temporaryRegister = false;
    this.preparationPrint = false;
    this.customerPrint = false;
    this.print = false;
    this.clearWithoutPrint = false;
    this.cancel = false;
    this.clear = false;
    this.mixClear = false;
    this.delivered = false;
  }
}
